import StandardMultiselectionField from '../StandardMultiselectionField'
import StandardUniselectionField from '../StandardUniselectionField'
import type { DataFieldStandardSelectionProps } from './DataFieldStandardSelection.types'

const DataFieldStandardSelection = ({
  variant,
  commonProps,
  filteraction,
  inputRef,
  onChangeValues,
  objectclassUuid,
  uuidCurrentSitemodelObjectclass,
  selectedOptions,
  isValid
}: DataFieldStandardSelectionProps) => {
  if (!filteraction) return null

  const standardSelectionStatusClass = isValid
    ? ('valid' as const)
    : ('default' as const)

  const standardSelectionSelectedOptions = Array.isArray(selectedOptions)
    ? selectedOptions
    : []

  if (variant === 'uniselection') {
    return (
      <StandardUniselectionField
        {...commonProps}
        filteractionUuid={filteraction}
        inputRef={inputRef}
        onChangeValues={onChangeValues}
        objectclassUuid={objectclassUuid}
        uuidCurrentSitemodelObjectclass={uuidCurrentSitemodelObjectclass}
        selectedOptions={standardSelectionSelectedOptions}
        statusClass={standardSelectionStatusClass}
      />
    )
  }

  return (
    <StandardMultiselectionField
      {...commonProps}
      filteractionUuid={filteraction}
      inputRef={inputRef}
      onChangeValues={onChangeValues}
      objectclassUuid={objectclassUuid}
      uuidCurrentSitemodelObjectclass={uuidCurrentSitemodelObjectclass}
      selectedOptions={standardSelectionSelectedOptions}
      statusClass={standardSelectionStatusClass}
    />
  )
}

export default DataFieldStandardSelection
